export default Object.freeze({
  Parent: 'FB7FCF39-0EA8-4106-9157-D9BE1BB99544',
});
